import React from 'react'
import { FormikProps, FormikValues } from 'formik'

export const useFormikRef = () => {
    return React.useRef<FormikProps<FormikValues>>(null)
}
